module.exports = {
  "calendar": "Kalend\xE1\u0159",
  "day": "den",
  "dayPeriod": "\u010D\xE1st dne",
  "endDate": "Kone\u010Dn\xE9 datum",
  "era": "letopo\u010Det",
  "hour": "hodina",
  "minute": "minuta",
  "month": "m\u011Bs\xEDc",
  "second": "sekunda",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Vybran\xE9 datum: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Vybran\xE9 obdob\xED: ".concat(args.startDate, " a\u017E ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Vybran\xFD \u010Das: ".concat(args.time);
  },
  "startDate": "Po\u010D\xE1te\u010Dn\xED datum",
  "timeZoneName": "\u010Dasov\xE9 p\xE1smo",
  "weekday": "den v t\xFDdnu",
  "year": "rok"
};